import React from 'react';
import { MdEdit } from 'react-icons/md';
import moment from 'moment';
import PropTypes from 'prop-types';

import './DateRangeCBI.css'

const getDateText = (date) => moment(date).format('MMM Do');

const DateRangeCBI = ({
  startDate, endDate, onClick,
}) => (
  <div
    role="button"
    tabIndex={0}
    onClick={(e) => onClick && onClick(e)}
    onKeyDown={(e) => onClick && onClick(e)}
  >
    <p className='data__range__box'>
      <span className='date__range__format'>
      {`${startDate ? getDateText(startDate): 'Up to date'}${endDate ? `-${getDateText(endDate)}` : ''}`}
      </span>
      { onClick && <MdEdit /> }
    </p>
  </div>
);

DateRangeCBI.propTypes = {
  startDate: PropTypes.string,
  endDate: PropTypes.string,
  onClick: PropTypes.func,
};

DateRangeCBI.defaultProps = {
  startDate: undefined,
  endDate: undefined,
  onClick: undefined,
};

export default DateRangeCBI;
